import styled from 'styled-components';

import { Badge } from '@components/badge';
import { IconIntegration } from '@components/icons/integration';
import { Separator } from '@components/separator';
import { SquareImage } from '@components/square-image';
import { Horizontal } from '@components/stack';
import { Tooltip } from '@components/tooltip';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { JourneyIntegrationIcon } from 'api/types';

type Props = {
  integrations?: JourneyIntegrationIcon[];
};

const MAX_INLINE = 3;
const CHIP_SIZE = 24;
const ICON_SIZE = 16;

export const JourneyIntegrationIcons = ({ integrations }: Props) => {
  if (!integrations || integrations.length === 0) return null;

  const visible = integrations.slice(0, MAX_INLINE);
  const hidden = integrations.slice(MAX_INLINE);
  const hiddenLabel = hidden.length > 0 ? hidden.map((i) => i.name).join(', ') : '';

  return (
    <>
      <Horizontal align="center" space={1}>
        {visible.map((integration) => (
          <Tooltip key={integration.shortId} content={integration.name}>
            <Chip role="img" aria-label={integration.name} tabIndex={0}>
              {integration.icon ? (
                <SquareImage src={integration.icon} size={ICON_SIZE} />
              ) : (
                <IconIntegration size={ICON_SIZE} color="textHelper" />
              )}
            </Chip>
          </Tooltip>
        ))}
        {hidden.length > 0 && (
          <Badge
            text={`+${hidden.length}`}
            size="md"
            variant="neutral"
            color="textSecondary"
            tooltip={hiddenLabel}
            aria-label={hiddenLabel}
            tabIndex={0}
          />
        )}
      </Horizontal>
      <Separator orientation="horizontal" style={{ maxHeight: pxToRem(32) }} />
    </>
  );
};

const Chip = styled.span({
  width: pxToRem(CHIP_SIZE),
  height: pxToRem(CHIP_SIZE),
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.color.white100,
  border: `1px solid ${theme.color.border10}`,
  borderRadius: pxToRem(6),
  boxShadow: theme.shadow.low,
  boxSizing: 'border-box',
  flexShrink: 0,
});
